interface TableListHeaderProps {
  title: string
  length: number
  action?: React.ReactNode
}

export const TableListHeader = ({ title, length, action }: TableListHeaderProps) => {
  return (
    <div className="flex w-full items-center justify-between">
      <div className="flex items-center">
        <h1 className="text-lg font-bold text-gray-900">{title}</h1>
        <p className="text-md ml-2 text-gray-600">{length}</p>
      </div>
      {action}
    </div>
  )
}
